import React from 'react'

import { Box, Display, FlexDirection, Overflow, SpaceScale } from '@gousto-internal/citrus-react'
import type { MenuRecipeTileRequestParams, RecipeUUID } from '@library/menu-service'

type BackgroundImageCrop = {
  width: number
  url: string
}

export type RecipeCardState = {
  isInBasket: boolean
  isOutOfStock: boolean
  quantity?: number
  numPortions?: MenuRecipeTileRequestParams['numPortions']
}

export type MerchandisingBannerFlexPortionProps = {
  renderFlexPortionBadge?: (recipeId: RecipeUUID) => React.ReactNode
  renderFlexPortionEditor?: (recipeId: RecipeUUID) => React.ReactNode
}

export type MerchandisingBannerActionProps = {
  getRecipeCardState: (recipeId: RecipeUUID) => RecipeCardState
  canAddRecipes: boolean
  reachedLimit: boolean
  onAddClick: (recipeId: RecipeUUID) => void
  onBlockedAddAttempt: () => void
  onCtaClick: (targetCategory: { id: string; slug: string }) => void
  onRecipeClick: (recipeId: RecipeUUID) => void
  onRemoveClick: (recipeId: RecipeUUID) => void
} & MerchandisingBannerFlexPortionProps

export const ScrollableRail = ({
  children,
  gap = 3,
}: {
  children: React.ReactNode
  gap?: number
}) => (
  <Box
    data-testid="collection-merchandising-rail"
    display={Display.Flex}
    flexDirection={FlexDirection.Row}
    gap={gap as SpaceScale}
    overflowX={Overflow.Scroll}
    style={{
      scrollbarWidth: 'none',
      WebkitOverflowScrolling: 'touch',
    }}
    paddingBottom={1}
    paddingRight={gap as SpaceScale}
  >
    {children}
  </Box>
)

export const getBackgroundImageUrl = (crops: BackgroundImageCrop[]) =>
  [...crops].sort((left, right) => right.width - left.width)[0]?.url
